import React, { useState, useRef, useEffect } from 'react';
import { Filter as FilterIcon, ChevronDown } from 'lucide-react';
import { HorizontalPillSkeleton } from '../index';
import './SortCards.css';

const CheapestIcon = ({ color = "#141B34" }) => (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28.8148 19.2089C28.7426 18.9201 28.4537 18.7756 28.1648 18.7756H24.5537V3.60894C24.5537 3.24783 24.1926 2.88672 23.8315 2.88672C22.8926 2.88672 22.4593 3.4645 22.1704 3.89783C21.8815 4.25894 21.8093 4.33116 21.6648 4.33116C21.5204 4.33116 21.4482 4.25894 21.1593 3.89783C20.8704 3.4645 20.3648 2.88672 19.4982 2.88672C18.6315 2.88672 18.1259 3.4645 17.837 3.89783C17.5482 4.25894 17.4759 4.33116 17.3315 4.33116C17.187 4.33116 17.1148 4.25894 16.8259 3.89783C16.537 3.4645 16.0315 2.88672 15.1648 2.88672C14.2982 2.88672 13.7926 3.4645 13.5037 3.89783C13.2148 4.25894 13.1426 4.33116 12.9982 4.33116C12.8537 4.33116 12.7815 4.25894 12.4926 3.89783C12.2037 3.4645 11.7704 2.88672 10.8315 2.88672C10.4704 2.88672 10.1093 3.24783 10.1093 3.60894V18.7756H6.49816C6.20927 18.7756 5.92038 18.9201 5.84816 19.2089C5.70371 19.4978 5.77594 19.7867 5.9926 20.0034L16.8259 31.5589C16.9704 31.7034 17.1148 31.7756 17.3315 31.7756C17.5482 31.7756 17.6926 31.7034 17.837 31.5589L28.6704 20.0034C28.887 19.7867 28.9593 19.4978 28.8148 19.2089ZM17.3315 29.9701L8.15927 20.2201H10.8315C11.1926 20.2201 11.5537 19.8589 11.5537 19.4978V5.05339C11.8426 5.4145 12.2759 5.77561 12.9982 5.77561C13.8648 5.77561 14.3704 5.19783 14.6593 4.7645C14.9482 4.40339 15.0204 4.33116 15.1648 4.33116C15.3093 4.33116 15.3815 4.40339 15.6704 4.7645C15.9593 5.19783 16.3926 5.77561 17.3315 5.77561C18.2704 5.77561 18.7037 5.19783 18.9926 4.7645C19.2815 4.40339 19.3537 4.33116 19.4982 4.33116C19.6426 4.33116 19.7148 4.40339 20.0037 4.7645C20.2926 5.19783 20.7982 5.77561 21.6648 5.77561C22.387 5.77561 22.8204 5.4145 23.1093 5.05339V19.4978C23.1093 19.8589 23.4704 20.2201 23.8315 20.2201H26.5037L17.3315 29.9701Z" fill={color} />
        <path d="M19.862 17.3346C18.8509 17.3346 18.0564 16.5402 18.0564 15.5291C18.0564 14.518 18.8509 13.7235 19.862 13.7235C20.8731 13.7235 21.6675 14.518 21.6675 15.5291C21.6675 16.5402 20.8731 17.3346 19.862 17.3346ZM19.862 15.168C19.6453 15.168 19.5009 15.3124 19.5009 15.5291C19.5009 15.7457 19.6453 15.8902 19.862 15.8902C20.0786 15.8902 20.2231 15.7457 20.2231 15.5291C20.2231 15.3124 20.0786 15.168 19.862 15.168ZM14.8064 12.2791C13.7953 12.2791 13.0009 11.4846 13.0009 10.4735C13.0009 9.46241 13.7953 8.66797 14.8064 8.66797C15.8175 8.66797 16.612 9.46241 16.612 10.4735C16.612 11.4846 15.8175 12.2791 14.8064 12.2791ZM14.8064 10.1124C14.5898 10.1124 14.4453 10.2569 14.4453 10.4735C14.4453 10.6902 14.5898 10.8346 14.8064 10.8346C15.0231 10.8346 15.1675 10.6902 15.1675 10.4735C15.1675 10.2569 15.0231 10.1124 14.8064 10.1124ZM13.7231 17.3346C13.5064 17.3346 13.362 17.2624 13.2175 17.118C12.9286 16.8291 12.9286 16.3957 13.2175 16.1069L20.4398 8.88464C20.7286 8.59575 21.162 8.59575 21.4509 8.88464C21.7398 9.17352 21.7398 9.60686 21.4509 9.89575L14.2286 17.118C14.0842 17.2624 13.9398 17.3346 13.7231 17.3346Z" fill={color} />
    </svg>
);

const BestIcon = ({ color = "#FF4E01" }) => (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.3342 31.7756C23.7162 31.7756 28.8898 26.602 28.8898 20.2201C28.8898 15.194 25.0034 10.168 21.7384 6.83227C19.861 4.91426 16.9095 6.13003 15.8974 8.61578C15.6998 9.10085 15.4755 9.59347 15.2166 10.1113C14.8035 10.9376 13.6953 11.283 12.9954 10.6802C11.9961 9.81952 10.5285 9.46749 9.7353 10.5212C7.56627 13.4026 5.77866 16.8113 5.77866 20.2201C5.77866 26.602 10.9523 31.7756 17.3342 31.7756Z" stroke={color} strokeWidth="2.16667" strokeLinejoin="round" />
        <path d="M14.4453 24.5551L20.2231 18.7773" stroke={color} strokeWidth="2.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.4453 18.7773H14.4583M20.2101 24.5551H20.2231" stroke={color} strokeWidth="2.88889" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const QuickestIcon = ({ color = "#141B34" }) => (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.14096 11.6156H15.6398M2.888 26.0013L10.829 18.1814C11.1345 17.8805 11.6118 17.8465 11.9563 18.1013L18.0892 22.6375C18.4504 22.9048 18.9544 22.853 19.2544 22.5177L30.744 9.68286M26.1557 8.66797H30.2322C31.0236 8.66797 31.6699 9.30464 31.686 10.1006L31.7769 14.5395" stroke={color} strokeWidth="2.16667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const SortCards = ({ selectedSort, setSelectedSort, prices = {}, isLoading = false, isTabLoading = false }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    if (isLoading) {
        return <HorizontalPillSkeleton count={4} />;
    }

    const formatPrice = (p) => {
        if (p && p !== Infinity && p !== 0) return `₹ ${p.toLocaleString('en-IN')}`;
        return isTabLoading || isLoading ? 'Searching...' : 'N/A';
    };

    const otherOptions = [
        { id: 'Cheapest', label: 'Cheapest' },
        { id: 'Quickest', label: 'Quickest' },
        { id: 'Early Arrival', label: 'Early Arrival' },
        { id: 'Early Departure', label: 'Early Departure' },
        { id: 'Late Departure', label: 'Late Departure' },
        { id: 'Closest Destination', label: 'Reach Closest' }
    ];

    const currentOtherLabel = otherOptions.find(opt => opt.id === selectedSort)?.label || 'Other';

    const sortOptions = [
        { id: 'Best', label: 'Best', price: formatPrice(prices.Best), icon: BestIcon },
        { id: 'Cheapest Available', label: 'Cheapest Available', price: formatPrice(prices.CheapestAvailable), icon: CheapestIcon },
        { id: 'Quickest Available', label: 'Quickest Available', price: formatPrice(prices.QuickestAvailable), icon: QuickestIcon }
    ];

    return (
        <div className="sort-cards-grid">
            {sortOptions.map(sort => {
                const isActive = selectedSort === sort.id;

                return (
                    <button
                        key={sort.id}
                        onClick={() => setSelectedSort(sort.id)}
                        className={`sort-card-btn ${isActive ? 'active' : ''}`}
                    >
                        <div className="sort-card-icon-wrapper">
                            <sort.icon color={isActive ? "#FF4E01" : "#141B34"} size={24} />
                        </div>
                        <div className="sort-card-info">
                            <h4 className="sort-card-label">{sort.label}</h4>
                            <span className="sort-card-price">{sort.price}</span>
                        </div>
                    </button>
                );
            })}

            <div className="other-sort-container" ref={dropdownRef}>
                <button
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    className={`sort-card-btn ${otherOptions.some(opt => opt.id === selectedSort) ? 'active' : ''}`}
                >
                    <div className="sort-card-icon-wrapper">
                        <FilterIcon color={otherOptions.some(opt => opt.id === selectedSort) ? "#FF4E01" : "#141B34"} size={24} />
                    </div>
                    <div className="sort-card-info">
                        <h4 className="sort-card-label">{currentOtherLabel}</h4>
                        <span className="sort-card-price">Sort</span>
                    </div>
                    <ChevronDown size={16} className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`} />
                </button>

                {isDropdownOpen && (
                    <div className="other-sort-dropdown">
                        {otherOptions.map(opt => (
                            <button
                                key={opt.id}
                                className={`dropdown-item ${selectedSort === opt.id ? 'active' : ''}`}
                                onClick={() => {
                                    setSelectedSort(opt.id);
                                    setIsDropdownOpen(false);
                                }}
                            >
                                {opt.label}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SortCards;
